import { render, staticRenderFns } from "./AddStep4.vue?vue&type=template&id=612e1d2a&scoped=true&"
import script from "./AddStep4.vue?vue&type=script&lang=js&"
export * from "./AddStep4.vue?vue&type=script&lang=js&"
import style0 from "./AddStep4.vue?vue&type=style&index=0&id=612e1d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e1d2a",
  null
  
)

export default component.exports